import React from 'react';
import '../style/selectcategory.css';

const CATEGORIES = [
  { value: 'Bar',         emoji: '🍸' },
  { value: 'Restaurant',  emoji: '🍽️' },
  { value: 'Cafe',        emoji: '☕' },
  { value: 'Dhaba',       emoji: '🫕' },
  { value: 'Bakery',      emoji: '🥐' },
  { value: 'Food Truck',  emoji: '🚚' },
  { value: 'Dessert',     emoji: '🍨' },
  { value: 'Juice Bar',   emoji: '🥤' },
  { value: 'Lounge',      emoji: '🛋️' },
  { value: 'Club',        emoji: '🎵' },
];

const SelectCategory = ({ setCategory, category }) => {

  // Normalize to array regardless of what arrives (string, null, undefined)
  const selected = Array.isArray(category) ? category : category ? [category] : [];

  const toggle = (value) => {
    const next = selected.includes(value)
      ? selected.filter(c => c !== value)
      : [...selected, value];
    setCategory(next);
  };

  return (
    <div className="category-selector">
      <h3>Choose your categories</h3>
      <p className="category-hint">Select all that apply</p>
      <div className="category-grid">
        {CATEGORIES.map(({ value, emoji }) => {
          const isSelected = selected.includes(value);
          return (
            <button
              key={value}
              type="button"
              className={`category-chip ${isSelected ? 'category-chip--selected' : ''}`}
              onClick={() => toggle(value)}
              aria-pressed={isSelected}
            >
              <span className="category-chip-emoji">{emoji}</span>
              <span>{value}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SelectCategory;